import { render, staticRenderFns } from "./cardProvince.vue?vue&type=template&id=7082ac12&scoped=true"
import script from "./cardProvince.vue?vue&type=script&lang=js"
export * from "./cardProvince.vue?vue&type=script&lang=js"
import style0 from "./cardProvince.vue?vue&type=style&index=0&id=7082ac12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082ac12",
  null
  
)

export default component.exports